// Reading questions come in units: one passage and the questions written for it. A session or test must show a
// unit's questions together and in order ("gap 1" before "gap 2"), the way the real papers do, instead of
// scattering them (a child once met "Which sentence best fits gap 5?" as question 1 of a section test).

const gapNo = (q) => { const m = String(q.q || '').match(/\bgap (\d+)\b/i); return m ? Number(m[1]) : null; };

/** The order of questions inside one unit: by gap number when they have one, otherwise as stored in the bank. */
export function unitOrder(qs, pool) {
  const pos = new Map(pool.map((q, i) => [q.id, i]));
  return [...qs].sort((a, b) => {
    const ga = gapNo(a), gb = gapNo(b);
    if (ga != null && gb != null && ga !== gb) return ga - gb;
    return (pos.get(a.id) ?? 0) - (pos.get(b.id) ?? 0);
  });
}

/**
 * Turn a selection into whole units: each chosen passage question brings the rest of its passage's questions with it,
 * placed together and in order where that passage first appears. Questions without a passage stay where they are.
 * Stops adding new units once `count` is reached; with `exact`, the result is cut to exactly `count`.
 * `exclude` holds ids that must not be pulled in (questions already used earlier in the session).
 */
export function groupByPassage(selected, pool, count, { exact = false, exclude = new Set() } = {}) {
  if (!selected.some((q) => q && q.passage)) return selected;
  const byPassage = new Map();
  for (const q of pool) if (q && q.passage && !exclude.has(q.id)) { if (!byPassage.has(q.passage)) byPassage.set(q.passage, []); byPassage.get(q.passage).push(q); }
  const out = [], have = new Set(), done = new Set();
  for (const q of selected) {
    if (!q || have.has(q.id)) continue;
    if (count && out.length >= count) break;
    if (!q.passage) { out.push(q); have.add(q.id); continue; }
    if (done.has(q.passage)) continue;
    done.add(q.passage);
    const unit = byPassage.get(q.passage) || [q];
    if (!unit.some((u) => u.id === q.id)) unit.push(q);
    for (const u of unitOrder(unit, pool)) if (!have.has(u.id)) { out.push(u); have.add(u.id); }
  }
  return exact && count ? out.slice(0, count) : out;
}
